import { URLS } from '@constants'
import { MapConfig } from '@types'

import { CopyMapRequestType } from '../../types/api/maps.api'

import { commonAPI } from './common.api'

export const mapsConfigApi = commonAPI.injectEndpoints({
  endpoints: build => ({
    createOrUpdateMapConfig: build.mutation<MapConfig, MapConfig>({
      query: data => ({
        url: `${URLS.FRONT_CFG}/mapConfig`,
        method: 'POST',
        body: data,
      }),
    }),
    copyMapConfig: build.mutation<null, CopyMapRequestType>({
      query: data => ({
        url: `${URLS.FRONT_CFG}/mapConfig/copy`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['MapConfigs'],
    }),
    fetchMapConfigById: build.query<MapConfig, { id: number }>({
      query: ({ id }) => ({
        url: `${URLS.FRONT_CFG}/mapConfig/id/${id}`,
        method: 'GET',
      }),
    }),
    fetchMapsConfigs: build.query<MapConfig[], void>({
      query: () => ({
        url: `${URLS.FRONT_CFG}/mapConfig`,
        method: 'GET',
      }),
      providesTags: ['MapConfigs'],
    }),
    deleteMapConfigById: build.mutation<null, { id: number }>({
      query: ({ id }) => ({
        url: `${URLS.FRONT_CFG}/mapConfig/id/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['MapConfigs'],
    }),
  }),
})

export const {
  useCreateOrUpdateMapConfigMutation,
  useCopyMapConfigMutation,
  useLazyFetchMapConfigByIdQuery,
  useLazyFetchMapsConfigsQuery,
  useFetchMapsConfigsQuery,
  useDeleteMapConfigByIdMutation,
} = mapsConfigApi
